(function(){
    angular.module('tmx-app').factory('ProfileLinkService', ['tmxResource', function(tmxResource){

        var User = tmxResource("User/GetById");

        ///////////////************************FUNCTIONS************************************/////////////////////
        User.updateUser = function(userData){
            return userData.$saveOrUpdate()
        };
        //User.getUserById = function(id){
        //    return tmxResource("User/GetById").getById(id);
        //
        //};
        User.getDeviceById = function(id){
            return tmxResource("device").getById(id);
        };
        return User;

    }]);//service end
})();//page end